<div mat-dialog class="dialog-backdrop">
    <h1 mat-dialog-title>Add Lading Status</h1>
    <div class="modal-contents" [formGroup]="status_form">
        <!-- Status Form -->
        <mat-form-field>
            <mat-label>Status</mat-label>
            <mat-select formControlName="status" required>
                <mat-option *ngFor="let status of status_options" [value]="status">{{status}}</mat-option>
            </mat-select>
        </mat-form-field>
        <!-- Date Form -->
        <mat-form-field>
            <mat-label>Date</mat-label>
            <input matInput [matDatepicker]="lading_status_datepicker" formControlName="date" required/>
            <mat-error>Choose a valid status date.</mat-error>
            <mat-datepicker-toggle matIconSuffix [for]="lading_status_datepicker"></mat-datepicker-toggle>
            <mat-datepicker #lading_status_datepicker>
                <mat-datepicker-actions>
                    <button mat-button matDatepickerCancel>Cancel</button>
                    <button mat-raised-button color="primary" matDatepickerApply>Confirm</button>
                </mat-datepicker-actions>              
            </mat-datepicker>
        </mat-form-field>
        <!-- Time Form -->
        <mat-form-field>
            <mat-label>Local Time</mat-label>
            <input matInput type="time" formControlName="time" required step="60"/>
            <mat-hint>Use the actual time in this timezone.</mat-hint>
            <mat-error>Choose a valid status time.</mat-error>
        </mat-form-field>
        <!-- Timezone Form -->
         <mat-form-field>
            <mat-label>Local Timezone</mat-label>
            <mat-select formControlName="timezone" required>
                <mat-option  *ngFor="let zone of setAutoselectedTimezone()" [value]="zone">{{formatTimezoneString(zone)}}, {{timezone_regions[zone]}}</mat-option>
            </mat-select>
            <mat-error>Choose the timezone for this status.</mat-error>
         </mat-form-field>
    </div>
    <div class="error-messages">
        <div *ngIf="status_form.get('status')?.errors && status_form.get('status')?.touched">Status is required</div>
    </div>
    <div *ngIf="saveErrorMessage" class="save-error" role="alert" aria-live="assertive" aria-atomic="true">
        <div class="save-error-heading">
            <svg *ngIf="saveErrorIsChronology" class="time-car" viewBox="0 0 64 40" fill="none" aria-hidden="true" focusable="false">
                <g stroke="currentColor" stroke-width="1.7" stroke-linejoin="round" stroke-linecap="round">
                    <path d="M7 27v-6l8-8h18l9 8h12l5 6v6h-8M39 33H22M10 33H5v-6"/>
                    <path d="m18 13-3-9 14-2 6 12M19 16h12l6 6H14l5-6ZM8 25h46M53 27h4M24 25v5h9"/>
                    <circle cx="16" cy="32" r="5"/><circle cx="45" cy="32" r="5"/>
                    <path d="M16 30v4m-2-2h4M45 30v4m-2-2h4M2 19h4M1 25h3M2 32h2"/>
                </g>
            </svg>
            <strong>{{ saveErrorTitle }}</strong>
        </div>
        <p>{{ saveErrorMessage }}</p>
    </div>
    <mat-dialog-actions>
        <button mat-flat-button (click)="onCloseModal(0)" color="primary" [disabled]="saving || confirmingMidnight">Cancel</button>
        <button mat-flat-button (click)="onSubmit()" color="primary" [disabled]="status_form.invalid || saving || confirmingMidnight">{{ saving ? 'Saving...' : 'Save' }}</button>
    </mat-dialog-actions>
</div>
